import { canonicalizeRoles } from './roles';

export interface SeatsSummaryScope {
  accountRole?: string | null;
  tenantId?: string | number | null;
  roles: readonly string[];
}

function tenantKey(value: string | number | null | undefined): string | null {
  if (value === null || value === undefined || value === '') return null;
  const text = String(value);
  return text.match(/^0{8}-0{4}-0{4}-0{4}-0*(\d+)$/)?.[1] ?? text;
}

/** Espelha os gates admin + tenant scope do BFF; a conta continua validada no servidor. */
export function canReadSeatsSummary(
  scope: SeatsSummaryScope,
  target: string | number | null | undefined,
): boolean {
  const requested = tenantKey(target);
  if (!requested) return false;
  const roles = canonicalizeRoles([...scope.roles]);
  if (scope.accountRole === 'account_owner') return true;
  if (roles.some((role) => role === 'master_admin' || role === 'super_admin')) return true;
  return roles.includes('tenant_admin') && tenantKey(scope.tenantId) === requested;
}

export function isSeatsForbidden(error: unknown): boolean {
  return (error as { response?: { status?: number } } | null)?.response?.status === 403;
}
